import { useEffect, useState } from "react";
import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { StickyFilterBar } from "../../../shared/ui/layouts/StickyFilterBar";
import { WorkOrderFilterBar } from "./ui/WorkOrderFilterBar";
import { WorkOrderList } from "./ui/WorkOrderList";
import { WorkOrderSyncStatus } from "./ui/WorkOrderSyncStatus";
import { useWorkOrderFilters } from "../../../features/work-order";
import { useIsMobile } from "../../../shared/hooks/useIsMobile";

export const WorkOrderPage = () => {
  const [lastSyncAt, setLastSyncAt] = useState<Date | null>(null);
  const [secondsAgo, setSecondsAgo] = useState<number | null>(null);
  const isMobile = useIsMobile();

  const { dataUpdatedAt, refetch, isFetching } = useWorkOrderFilters();

  useEffect(() => {
    if (dataUpdatedAt) setLastSyncAt(new Date(dataUpdatedAt));
  }, [dataUpdatedAt]);

  useEffect(() => {
    if (!lastSyncAt) return;
    const tick = () =>
      setSecondsAgo(Math.floor((Date.now() - lastSyncAt.getTime()) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [lastSyncAt]);

  function handleSync() {
    refetch();
  }

  const syncStatus = (
    <WorkOrderSyncStatus
      secondsAgo={secondsAgo}
      isFetching={isFetching}
      onRefresh={handleSync}
      className={isMobile ? "w-full" : undefined}
    />
  );

  return (
    <PageLayout
      pageTitle="Reparaturaufträge"
      // On a phone the pill is wider than the room left beside the title, so it moves out of the
      // header and onto its own row above the filters instead of squeezing the heading.
      headerChildren={isMobile ? undefined : syncStatus}
    >
      <div className="flex w-full flex-col gap-3 md:gap-4">
        {isMobile && syncStatus}
        <StickyFilterBar>
          <WorkOrderFilterBar />
        </StickyFilterBar>
        <WorkOrderList />
      </div>
    </PageLayout>
  );
};
